import { attachmentService, cameraService } from "client-app-core";
import { subscribeFOVs, unsubscribeFOVs } from "orion-components/GlobalData/Actions";
import keys from "lodash/keys";
import pull from "lodash/pull";
import uniq from "lodash/uniq";
import { updateContext } from "orion-components/ContextualData/Actions";

export { linkEntities, unlinkEntities } from "./entityProfileActions";
export { addRemoveFromCollections, addRemoveFromEvents, updateActivityFilters } from "./commonActions";

export const attachFilesToCamera = (cameraId, entityType, files) => {
	return () => {
		attachmentService.uploadFiles(cameraId, "camera", files, (err, result) => {
			if (err) {
				console.log(err);
			}
			console.log(result);
		});
	};
};

export const showFOV = (cameraId) => {
	return (dispatch, getState) => {
		let cameraIds = [cameraId];
		const fovs = getState().globalData.fovs;

		//Removes duplicate entries.
		if (fovs) cameraIds = uniq([...cameraIds, ...keys(fovs.data)]);

		dispatch(subscribeFOVs(cameraIds));
	};
};

export const hideFOV = (cameraId) => {
	return (dispatch, getState) => {
		let cameraIds = [];
		const fovs = getState().globalData.fovs;

		if (fovs) cameraIds = pull(keys(fovs.data), cameraId);
		dispatch(unsubscribeFOVs([cameraId], fovs.subscription));
		if (cameraIds.length === 0) return;
		dispatch(subscribeFOVs(cameraIds));
	};
};

export const updateCameraGlobally = (cameraId, camera, updateEntityData) => {
	return (dispatch, getState) => {
		cameraService.update(cameraId, camera, updateEntityData, (err, response) => {
			if (err) {
				console.log(err, response);
			} else if (response?.changes) {
				const context = getState().contextualData[cameraId]?.entity || {};
				const camera = response.changes[0]?.new_val || {};
				dispatch(updateContext(cameraId, { ...context, ...camera }));
			}
		});
	};
};
